export enum AdTrackingEvent {
  AD_UNKNOWN_EVENT = 'Unknown',
  AD_BREAK_STARTED_EVENT = 'Ad Break Started',
  AD_STARTED_EVENT = 'Ad Started',
  AD_FIRST_QUARTILE_EVENT = 'Ad First Quartile',
  AD_MIDPOINT_EVENT = 'Ad Midpoint',
  AD_THIRD_QUARTILE_EVENT = 'Ad Third Quartile',
  AD_PAUSED_EVENT = 'Ad Paused',
  AD_RESUMED_EVENT = 'Ad Resumed',
  AD_MUTED_EVENT = 'Ad Muted',
  AD_UNMUTED_EVENT = 'Ad Unmuted',
  AD_ENDED_EVENT = 'Ad Ended',
  AD_BREAK_ENDED_EVENT = 'Ad Break Ended',
  AD_SKIPPED_EVENT = 'Ad Skipped',
  AD_PLAYER_EXPANDED_EVENT = 'Ad Player Expanded',
  AD_PLAYER_COLLAPSED_EVENT = 'Ad Player Collapsed',
  AD_EXPANDED_EVENT = 'Ad Expanded',
  AD_COLLAPSED_EVENT = 'Ad Collapsed',
  AD_CLICK = 'Ad Click',
  AD_VIDEO_CLICKED = 'Ad Video Clicked',
  AD_VIDEO_ICON_CLICKED = 'Ad Video Icon Clicked',
  AD_IMPRESSION = 'Ad Impression',
  AD_USER_CLOSE = 'Ad User Close',
  AD_INTERACTION = 'Ad Interaction',
  AD_SKIPPABLE_STATE_CHANGED = 'Ad Skippable State Changed',
  AD_VOLUME_CHANGED = 'Ad Volume Changed',
  AD_VOLUME_MUTED = 'Ad Volume Muted',
}
